import ReactDOM from "react-dom";



const LoadingWrapper = ({text, productPage}) => {
    return <>   
    {ReactDOM.createPortal(
        <div className='loading_wrapper'>
            <div className='loading_wrapper_backdrop'>
                <div className='loading_wrapper_container'>
                    <div className='loading_wrapper_loader'></div>
                    <div className='loading_wrapper_message'>{text}</div>
                </div>
            </div>
        </div>,
        document.getElementById("overlay-root")
    )}
    </>
}

export default LoadingWrapper